import React from "react";
import { useLocation, Outlet } from "react-router-dom"; // import Outlet
import { Layout } from "antd";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumbs from "../hooks/Breadcrumbs";

const { Content } = Layout;

const MainLayout = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";
  const isCityPage = location.pathname.startsWith("/city/");

  return (
    <Layout className="p-0 bg-white">
      <Header />
      <Content className="p-4">
        <div className="container">
          {!isLandingPage && !isCityPage && <Breadcrumbs />}
        </div>
        <Outlet /> {/* This renders the matched child route */}
      </Content>
      <Footer />
    </Layout>
  );
};

export default MainLayout;
